import React from 'react';
import { isRiskAnalysisFlow } from '../../../../../../common/src/utils/globalVariables';
import LinkInputComponent from './LinkInputComponent';
import LinkInputRiskAnalysis from '../../../../../../risk-analysis/src/components/input/LinkInputComponent';
import { FlowsQuestion } from '../../../../types/FlowsTypes';

interface Props {
  question: FlowsQuestion;
}

const LinkInputPicker: React.FC<React.PropsWithChildren<Props>> = ({
  ...props
}) => {
  if (isRiskAnalysisFlow()) return <LinkInputRiskAnalysis {...props} />;
  return <LinkInputComponent {...props} />;
};

export default LinkInputPicker;
